import {FC, useState, useEffect, Fragment, useRef} from 'react'

import {Modal} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

const api = new Api()

type Props = {
  showModal: boolean
  handleShowModal: any
}

const FormContent: React.FC<Props> = ({showModal, handleShowModal}) => {
  const fileRef = useRef<any>(null)

  const [isShow, setIsShow] = useState<boolean>(true)
  const [loading, setLoading] = useState(false)
  const [loadingTemplate, setLoadingTemplate] = useState(false)
  const [errors, setErrors] = useState<any>({})
  const [formValue, setFormValue] = useState({})
  const [errorsDetail, setErrorsDetail] = useState<any>({})

  useEffect(() => {
    setIsShow(showModal)
  }, [showModal])

  const handleClose = (isOk: boolean) => {
    setIsShow(false)
    handleShowModal(false, isOk)
    setErrors({})
    setErrorsDetail({})
    setFormValue({})
  }

  const handleInput = (name: string, e: any) => {
    setFormValue({...formValue, [name]: e.target.files[0]})
    setErrors({})
    setErrorsDetail({})
  }

  const submit = () => {
    setLoading(true)
    api
      .importTemplateImport(formValue)
      .then((response: any) => {
        setLoading(false)

        const {data} = response?.data

        toast.success(response?.data?.meta?.message)
        if (data?.detail_gagal?.length > 0) {
          fileRef.current.value = ''
          setErrorsDetail({file: data?.detail_gagal})
          return
        }

        handleClose(true)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response

        toast.error(data?.meta?.message ?? data?.message)
        setErrors(data?.meta?.error ?? data?.errors)
        fileRef.current.value = ''

        if (data?.detail_gagal?.length > 0) {
          setErrorsDetail({file: data?.detail_gagal})
        }
      })
  }

  const downloadBase64File = (base64Data: string, filename: string) => {
    const link = document.createElement('a')
    link.href = base64Data // langsung pakai data URI
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const fetchTemplate = () => {
    setLoadingTemplate(true)
    api
      .getTemplateImport()
      .then((response: any) => {
        setLoadingTemplate(false)
        const {data} = response?.data
        downloadBase64File(data?.file, data?.name)
      })
      .catch((error: any) => {
        setLoadingTemplate(false)
        const {data} = error.response
        setErrors(data?.meta?.error)
      })
  }

  return (
    <Modal show={isShow} centered size='lg'>
      <div className='p-10'>
        <div className='row align-items-center'>
          <div className='col-md-2'>
            <p className='fw-bold mb-0'>Template File</p>
          </div>
          <div className='col-md-10'>
            <button
              disabled={loadingTemplate}
              type='button'
              className='btn btn-sm mt-3 text-primary'
              style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
              onClick={fetchTemplate}
            >
              <i className='fa fa-download text-primary' />
              {loadingTemplate ? 'Loading...' : 'Download Template'}
            </button>
          </div>
        </div>

        <div className='row align-items-center mt-5'>
          <div className='col-md-2'>
            <p className='fw-bold mb-0'>Import File</p>
          </div>
          <div className='col-md-10'>
            <input
              type='file'
              ref={fileRef}
              className={`form-control mt-3 ${errors?.file ? 'border-danger' : ''}`}
              onChange={(e) => {
                handleInput('file', e)
              }}
            />

            {errors?.file && <p className='text-danger mt-3'>{errors?.file}</p>}
            {errorsDetail?.file &&
              errorsDetail.file.map((item: any, index: number) => (
                <p className='text-danger mt-3' key={index}>
                  {item}
                </p>
              ))}
          </div>
        </div>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          onClick={() => submit()}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Submit'}
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={() => handleClose(false)}
          disabled={loading}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const FormModal: React.FC<Props> = ({showModal, handleShowModal}) => {
  return <FormContent showModal={showModal} handleShowModal={handleShowModal} />
}

export default FormModal
